export const SURGERIES_ROUTES = {
  order              : 'formulario/orden',
  surgicalTable: 'tabla-quirurgica',
  historyPatient     : 'historial/ordenes/paciente',
  historyProfessional: 'historial/ordenes/profesional',
};
